import { useNavigate } from 'react-router-dom';

import Orders24 from '@common/components/icons/Orders24';
import Reconciliation24 from '@common/components/icons/Reconciliation24';
import { NavigationBox } from '@common/components/NavigationBox/NavigationBox';
import { NavigationGrid } from '@common/components/NavigationGrid/NavigationGrid';
import { PageLayout } from '@common/components/PageLayout';
import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { paths } from '@config/paths';

export default function ReportsPage(): React.ReactNode {
	const navigate = useNavigate();
	const servicesProviderId = useCurrentServicesProviderId();

	const handleOrdersClick = (): void => {
		if (servicesProviderId) {
			navigate(paths.reportsOrders.getHref(servicesProviderId));
		}
	};

	const handlePaymentsClick = (): void => {
		if (servicesProviderId) {
			navigate(paths.reportsPayments.getHref(servicesProviderId));
		}
	};

	return (
		<PageLayout title='Reports'>
			<NavigationGrid>
				<NavigationBox
					icon={<Orders24 />}
					title='Orders'
					description='See all sales, payments, and amounts owed vs. received.'
					onPress={handleOrdersClick}
				/>
				<NavigationBox
					icon={<Reconciliation24 />}
					title='Payment reconciliation'
					description='Track payouts with fees and statuses to confirm what was sent.'
					onPress={handlePaymentsClick}
				/>
			</NavigationGrid>
		</PageLayout>
	);
}
